// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.super-pickem-pick-stats-single-card-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  width: 90%;
  min-height: 155px;
  min-width: 325px;
  max-width: 550px;
  margin: 0 auto;
  margin-top: 16px;
  margin-bottom: 32px;
  padding: 0px 8px;
}
@media (max-width: 900px) {
  .super-pickem-pick-stats-single-card-container {
    max-width: 450px;
  }
}

.super-pickem-pick-stats-single-label-container {
  display: flex;
  flex-direction: row;
  width: 100%;
  background-color: #002129;
  justify-content: center;
}

.super-pickem-pick-stats-single-label {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  color: #fff;
  font-size: 24px !important;
  font-weight: 700 !important;
}
@media (max-width: 900px) {
  .super-pickem-pick-stats-single-label {
    font-size: 20px !important;
  }
}

.super-pickem-pick-stats-single-stat-boxes-main-container {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}

.super-pickem-pick-stats-single-card-footer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border: 1px solid #002129;
  border-radius: 0px 0px 8px 8px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  height: 25px;
  padding: 0px 10px;
}

.super-pickem-pick-stats-single-card-footer-text {
  font-size: 16px !important;
  font-weight: 500 !important;
  color: #002129;
}
@media (max-width: 900px) {
  .super-pickem-pick-stats-single-card-footer-text {
    font-size: 12px !important;
  }
}

.super-pickem-pick-stats-single-card-footer-text-container {
  display: flex;
  align-items: center;
  width: 50%;
}

.super-pickem-pick-stats-single-header {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: #E5E5E5;
  min-height: 45px; /* Changed from 31px to 40px */
  width: 100%;
  border: 1px solid #002129;
  border-radius: 8px 8px 0px 0px;
  padding: 0px 8px;
}
@media (max-width: 900px) {
  .super-pickem-pick-stats-single-header {
    min-height: 31px; /* Keep original height for mobile */
  }
}

.super-pickem-pick-stats-single-team-logo {
  width: 36px;
  height: 36px;
  object-fit: contain;
  margin: 0 16px;
}
@media (max-width: 900px) {
  .super-pickem-pick-stats-single-team-logo {
    width: 24px;
    height: 24px;
  }
}

.super-pickem-pick-stats-single-team-name {
  font-weight: 500 !important;
  font-size: 20px !important;
  margin: 0 4px;
  width: 70px;
}
@media (max-width: 900px) {
  .super-pickem-pick-stats-single-team-name {
    font-size: 16px !important;
    width: 50px;
  }
}

.super-pickem-pick-stats-single-team-score-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.super-pickem-pick-stats-single-team-score {
  font-weight: 500;
  font-size: 16px !important;
  margin: 0 4px;
  width: 70px;
}
@media (max-width: 900px) {
  .super-pickem-pick-stats-single-team-score {
    font-size: 12px !important;
    width: 50px;
  }
}

.super-pickem-pick-stats-single-at-symbol {
  font-weight: 500 !important;
  font-size: 20px !important;
  margin: 0 8px;
  width: 70px;
}
@media (max-width: 900px) {
  .super-pickem-pick-stats-single-at-symbol {
    font-size: 16px !important;
    width: 50px;
  }
}

.super-pickem-pick-stats-single-stat-box-container {
  display: flex;
  flex-direction: column;
  padding: 8px 0px;
  width: 100%;
  border-right: 1px solid #002129;
  border-left: 1px solid #002129;
}

.super-pickem-pick-stats-single-pill-box-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 83%;
  border: 1px solid #002129;
  border-radius: 8px;
  margin: 0 auto;
}

.super-pickem-pick-stats-single-stat-box {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.super-pickem-pick-stats-single-info-box-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  padding: 12px 0px;
}

.super-pickem-pick-stats-single-info-total-text-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 36px;
  margin-bottom: 8px;
}
@media (max-width: 900px) {
  .super-pickem-pick-stats-single-info-total-text-container {
    height: 24px;
  }
}

.super-pickem-pick-stats-single-info-total-text {
  font-size: 18px !important;
  font-weight: 500 !important;
  color: #002129;
}
@media (max-width: 900px) {
  .super-pickem-pick-stats-single-info-total-text {
    font-size: 14px !important;
  }
}

.super-pickem-pick-stats-single-info-header-text {
  font-size: 16px !important;
  font-weight: 500 !important;
  text-decoration: underline;
  color: #002129;
}
@media (max-width: 900px) {
  .super-pickem-pick-stats-single-info-header-text {
    font-size: 12px !important;
  }
}

.super-pickem-pick-stats-single-info-main-text {
  font-size: 20px !important;
  font-weight: 500 !important;
  color: #002129;
}
@media (max-width: 900px) {
  .super-pickem-pick-stats-single-info-main-text {
    font-size: 16px !important;
  }
}

.super-pickem-pick-stats-single-info-conditional-text {
  font-size: 18px !important;
  font-weight: 500 !important;
  color: #002129;
}
@media (max-width: 900px) {
  .super-pickem-pick-stats-single-info-conditional-text {
    font-size: 14px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SuperPickem/PoolPicks/PickStatsCard/PickStatsCardSingle.scss"],"names":[],"mappings":"AACA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAAJ;AAEI;EAfJ;IAgBQ,gBAAA;EACN;AACF;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,WAAA;EACA,0BAAA;EACA,2BAAA;AACJ;AACI;EATJ;IAUQ,0BAAA;EAEN;AACF;;AACA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,8BAAA;EACA,mBAAA;AAEJ;;AACA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,yBAAA;EACA,8BAAA;EACA,2CAAA;EACA,YAAA;EACA,iBAAA;AAEJ;;AACA;EACI,0BAAA;EACA,2BAAA;EACA,cAAA;AAEJ;AAAI;EALJ;IAMQ,0BAAA;EAGN;AACF;;AAAA;EACI,aAAA;EACA,mBAAA;EACA,UAAA;AAGJ;;AAMA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA,EAAA,8BAAA;EACA,WAAA;EACA,yBAAA;EACA,8BAAA;EACA,gBAAA;AAHJ;AAKI;EAZJ;IAaQ,gBAAA,EAAA,oCAAA;EAFN;AACF;;AAKA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AAFJ;AAKI;EAPJ;IAQQ,WAAA;IACA,YAAA;EAFN;AACF;;AAKA;EACI,2BAAA;EACA,0BAAA;EACA,aAAA;EACA,WAAA;AAFJ;AAII;EANJ;IAOQ,0BAAA;IACA,WAAA;EADN;AACF;;AAIA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AADJ;;AAIA;EACI,gBAAA;EACA,0BAAA;EACA,aAAA;EACA,WAAA;AADJ;AAGI;EANJ;IAOQ,0BAAA;IACA,WAAA;EAAN;AACF;;AAGA;EACI,2BAAA;EACA,0BAAA;EACA,aAAA;EACA,WAAA;AAAJ;AAEI;EANJ;IAOQ,0BAAA;IACA,WAAA;EACN;AACF;;AAMA;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,+BAAA;EACA,8BAAA;AAHJ;;AAMA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;AAHJ;;AAMA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;AAHJ;;AAUA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,uBAAA;EACA,iBAAA;AAPJ;;AAUA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AAPJ;AASI;EAPJ;IAQQ,YAAA;EANN;AACF;;AASA;EACI,0BAAA;EACA,2BAAA;EACA,cAAA;AANJ;AAQI;EALJ;IAMQ,0BAAA;EALN;AACF;;AAQA;EACI,0BAAA;EACA,2BAAA;EACA,0BAAA;EACA,cAAA;AALJ;AAOI;EANJ;IAOQ,0BAAA;EAJN;AACF;;AAOA;EACI,0BAAA;EACA,2BAAA;EACA,cAAA;AAJJ;AAMI;EALJ;IAMQ,0BAAA;EAHN;AACF;;AAMA;EACI,0BAAA;EACA,2BAAA;EACA,cAAA;AAHJ;AAKI;EALJ;IAMQ,0BAAA;EAFN;AACF","sourcesContent":["// PickStatsCard.js\n.super-pickem-pick-stats-single-card-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    border-radius: 8px;\n    width: 90%;\n    min-height: 155px;\n    min-width: 325px;\n    max-width: 550px;\n    margin: 0 auto;\n    margin-top: 16px;\n    margin-bottom: 32px;\n    padding: 0px 8px;\n    \n    @media (max-width: 900px) {\n        max-width: 450px;\n    }\n}\n\n.super-pickem-pick-stats-single-label-container {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    background-color: #002129;\n    justify-content: center;\n}\n\n.super-pickem-pick-stats-single-label {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 50%;\n    color: #fff;\n    font-size: 24px !important;\n    font-weight: 700 !important;\n\n    @media (max-width: 900px) {\n        font-size: 20px !important;\n    }\n}\n\n.super-pickem-pick-stats-single-stat-boxes-main-container {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.super-pickem-pick-stats-single-card-footer {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    border: 1px solid #002129;\n    border-radius: 0px 0px 8px 8px;\n    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n    height: 25px;\n    padding: 0px 10px;\n}\n\n.super-pickem-pick-stats-single-card-footer-text {\n    font-size: 16px !important;\n    font-weight: 500 !important;\n    color: #002129;\n\n    @media (max-width: 900px) {\n        font-size: 12px !important;\n    }\n}\n\n.super-pickem-pick-stats-single-card-footer-text-container {\n    display: flex;\n    align-items: center;\n    width: 50%;\n}\n\n\n\n\n\n\n// PickStatsCardHeader.js\n.super-pickem-pick-stats-single-header {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    background-color: #E5E5E5;\n    min-height: 45px; /* Changed from 31px to 40px */\n    width: 100%;\n    border: 1px solid #002129;\n    border-radius: 8px 8px 0px 0px;\n    padding: 0px 8px;\n    \n    @media (max-width: 900px) {\n        min-height: 31px; /* Keep original height for mobile */\n    }\n}\n\n.super-pickem-pick-stats-single-team-logo {\n    width: 36px;\n    height: 36px;\n    object-fit: contain;\n    margin: 0 16px;\n    \n\n    @media (max-width: 900px) {\n        width: 24px;\n        height: 24px;\n    }\n}\n\n.super-pickem-pick-stats-single-team-name {\n    font-weight: 500 !important;\n    font-size: 20px !important;\n    margin: 0 4px;\n    width: 70px;\n\n    @media (max-width: 900px) {\n        font-size: 16px !important;\n        width: 50px;\n    }\n}\n\n.super-pickem-pick-stats-single-team-score-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.super-pickem-pick-stats-single-team-score {\n    font-weight: 500;\n    font-size: 16px !important;\n    margin: 0 4px;\n    width: 70px;\n\n    @media (max-width: 900px) {\n        font-size: 12px !important;\n        width: 50px;\n    }\n}\n\n.super-pickem-pick-stats-single-at-symbol {\n    font-weight: 500 !important;\n    font-size: 20px !important;\n    margin: 0 8px;\n    width: 70px;\n\n    @media (max-width: 900px) {\n        font-size: 16px !important;\n        width: 50px;\n    }\n}\n\n\n\n\n// PickStatsStatBox.js\n.super-pickem-pick-stats-single-stat-box-container {\n    display: flex;\n    flex-direction: column;\n    padding: 8px 0px;\n    width: 100%;\n    border-right: 1px solid #002129;\n    border-left: 1px solid #002129;\n}\n\n.super-pickem-pick-stats-single-pill-box-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    width: 83%;\n    border: 1px solid #002129;\n    border-radius: 8px;\n    margin: 0 auto;\n}\n\n.super-pickem-pick-stats-single-stat-box {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n}\n\n\n\n\n// PickStatsInfoBox.js\n.super-pickem-pick-stats-single-info-box-container {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    justify-content: center;\n    padding: 12px 0px;\n}\n\n.super-pickem-pick-stats-single-info-total-text-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 36px;\n    margin-bottom: 8px;\n\n    @media (max-width: 900px) {\n        height: 24px;\n    }\n}\n\n.super-pickem-pick-stats-single-info-total-text {\n    font-size: 18px !important;\n    font-weight: 500 !important;\n    color: #002129;\n\n    @media (max-width: 900px) {\n        font-size: 14px !important;\n    }\n}\n\n.super-pickem-pick-stats-single-info-header-text {\n    font-size: 16px !important;\n    font-weight: 500 !important;\n    text-decoration: underline;\n    color: #002129;\n\n    @media (max-width: 900px) {\n        font-size: 12px !important;\n    }\n}\n\n.super-pickem-pick-stats-single-info-main-text {\n    font-size: 20px !important;\n    font-weight: 500 !important;\n    color: #002129;\n\n    @media (max-width: 900px) {\n        font-size: 16px !important;\n    }\n}\n\n.super-pickem-pick-stats-single-info-conditional-text {\n    font-size: 18px !important;\n    font-weight: 500 !important;\n    color: #002129;\n\n    @media (max-width: 900px) {\n        font-size: 14px !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
